import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Header from "../../Header/Header";

import { privateRequest } from "../../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Editor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";

const options = [
  { value: "apple", label: "Apple" },
  { value: "banana", label: "Banana" },
  { value: "orange", label: "Orange" },
];

function NewService() {
  const navigate = useNavigate();

  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editorData, setEditorData] = useState("");
  const [editorData1, setEditorData1] = useState("");
  const [loading, setLoading] = useState(false);
  const [combineData, setCombineData] = useState([]);
  const [SelectServiceType, setSelectedServiceType] = useState();
  const [Name, setName] = useState("");
  const [ServiceStatus, setServiceStatus] = useState(1);
  const [Time, setTime] = useState("");
  const [selectedParentCategory, setSelectedParentCategory] = useState();
  const [serviceVariants, setServiceVariants] = useState([]);
  const [selectedChildCategories, setSelectedChildCategories] = useState([]);
  const [selectedShowCategories, setSelectedShowCategories] = useState();
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [SelectedServiceGroup, setSelectedServiceGroup] = useState([]);
  const [ServiceTypeOptions, setServiceTypeOptions] = useState([]);
  const [isDiscription, setisDiscription] = useState(false);

  useEffect(() => {
    if (SelectServiceType !== undefined) {
      const updatedVariants = SelectServiceType.map((serviceType) => {
        const existingVariant = serviceVariants.find(
          (variant) => variant.ServiceType === serviceType.selectedIds
        );
        console.log("existingVariant", existingVariant);
        if (existingVariant) {
          return existingVariant;
        } else {
          return {
            ServiceType: serviceType._id,
            VariantDescription: [
              {
                regularPrice: "",
                salePrice: "",
                serviceDiscount: "",
                ServiceGroup: "",
                ServiceTiming: "",
                Imagee: "",
                ShortDiscription: "",
                Status: "",
                Discription: "",
                ShowInChildCategory: "",
              },
            ],
          };
        }
      });

      setServiceVariants(updatedVariants);
    }
  }, [SelectServiceType]);
  // useEffect(() => {
  //   if (SelectServiceType !== undefined && serviceVariants.length >= 0) {
  //     const initialVariants = SelectServiceType?.map(() => ({
  //       VariantDescription: [
  //         {
  //           regularPrice: "",
  //           salePrice: "",
  //           serviceDiscount: "",
  //           ServiceGroup: "",
  //           ServiceTiming: "",
  //           Imagee: "",
  //           ShortDiscription: "",
  //           Status: "",
  //           Discription: "",
  //           ShowInChildCategory: "",
  //           IsServiceDiscription: false,
  //         },
  //       ],
  //     }));

  //     setServiceVariants(initialVariants);
  //   }
  // }, [SelectServiceType]);

  console.log("SelectServiceType", serviceVariants);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const handleChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
  };
  const handleChange1 = (event, editor) => {
    const data = editor.getData();
    setEditorData1(data);
  };
  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // setSelectedFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (serviceVariants?.length == 0) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "please select at least one service type",
      });
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("ServiceName", Name);
      formData.append("PCatId", selectedParentCategory);
      formData.append("ChildCatIDs", selectedChildCategories);

      serviceVariants.forEach((variant, index) => {
        formData.append(
          `ServiceVarients[${index}][ServiceType]`,
          variant.ServiceType
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][regularPrice]`,
          variant.VariantDescription[0].regularPrice
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceTime]`,
          variant.VariantDescription[0].ServiceTiming
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][salePrice]`,
          variant.VariantDescription[0].salePrice
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][serviceDiscount]`,
          variant.VariantDescription[0].serviceDiscount
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ProductCost]`,
          variant.VariantDescription[0].ProductCost
        );
        console.log(
          "variant.VariantDescription[0].ServiceGroup",
          variant.VariantDescription[0].ServiceGroup
        );
        {
          variant.VariantDescription[0].ServiceGroup &&
            variant.VariantDescription[0].ServiceGroup.map((groupId) => {
              formData.append(
                `ServiceVarients[${index}][VarientDiscription][ServiceGroups]`,
                groupId
              );
            });
        }
        {
          variant.VariantDescription[0].ShowInChildCategory &&
            variant.VariantDescription[0].ShowInChildCategory.map((groupId) => {
              formData.append(
                `ServiceVarients[${index}][VarientDiscription][ShowInChildCategory]`,
                groupId
              );
            });
        }

        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceDiscription]`,
          variant.VariantDescription[0].Discription
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ShortDiscription]`,
          variant.VariantDescription[0].ShortDiscription
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][ServiceImage]`,
          variant.VariantDescription[0].Imagee
        );
        formData.append(
          `ServiceVarients[${index}][VarientDiscription][IsServiceDiscription]`,
          variant.VariantDescription[0].isDiscription == true ? true : false
        );
      });

      const response = await privateRequest.post(
        "Service/AddServices",
        formData
      );

      console.log("response", response);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Data added successfully!",
      });
      setLoading(false);
      navigate("/service");
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response.data.message,
      });
      console.error("Error creating service:", error);
    }
  };

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory(selectedOption?.value);
  };

  const filteredChildCategories =
    combineData &&
    combineData?.childCategories?.filter(
      (category) => category?.PCName[0] === selectedParentCategory
    );

  const filteredServiceGroups = combineData?.serviceGroups?.filter(
    (group) => group.PCName[0] === selectedParentCategory
  );

  // const filteredServiceTypes = combineData?.serviceTypes?.filter(
  //   (type) => type.PCName[0] === selectedParentCategory
  // );

  const filteredServiceTypes = combineData?.serviceTypes?.filter((type) =>
    type.PCName.includes(selectedParentCategory)
  );

  useEffect(() => {
    const childCategorySelectOptions = filteredChildCategories?.map(
      (category) => ({
        value: category._id,
        label: category.CCName,
      })
    );
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.childCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = filteredServiceGroups?.map((group) => ({
      value: group._id,
      label: group.GroupName,
    }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  useEffect(() => {
    const serviceTypeSelectOptions = filteredServiceTypes?.map((type) => ({
      value: type._id,
      label: type.Name,
    }));
    setServiceTypeOptions(serviceTypeSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceTypes]);

  const handleVariantChangee = (serviceType, index, field, value) => {
    console.log("serviceType", serviceType);
    console.log("index", index);
    console.log("field", field);
    console.log("value", value);
    setServiceVariants((prevVariants) => {
      return prevVariants.map((variant, i) => {
        if (i === index) {
          return {
            ...variant,
            ServiceType: serviceType,
            VariantDescription: variant.VariantDescription.map(
              (description, j) => {
                if (j === 0) {
                  return {
                    ...description,
                    [field]: value,
                  };
                }
                return description;
              }
            ),
          };
        }
        return variant;
      });
    });
  };

  useEffect(() => {
    getAllDocumentData();
  }, []);

  console.log("variants", serviceVariants);

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Services</span>
                    </p>
                    <Link
                      to="/service/"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>All Services
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <form>
                    <div className="card" style={{ minHeight: "500px" }}>
                      <div className="card-body table-responsive">
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Name</label>
                              <input
                                type="text"
                                value={Name}
                                onChange={(e) => setName(e.target.value)}
                                id="inputName"
                                className="form-control"
                                placeholder="Service Name"
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Parent Category</label>
                              <Select
                                isClearable
                                label={selectedParentCategory}
                                onChange={(selectedOption) => {
                                  handleParentCategoryChange(selectedOption);
                                  console.log(selectedOption);
                                }}
                                options={
                                  combineData?.parentCategories?.map(
                                    (category) => ({
                                      value: category._id,
                                      label: category.PCName,
                                    })
                                  ) || []
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Child Category</label>
                              <Select
                                isClearable
                                options={childCategoryOptions}
                                onChange={(e) => {
                                  setSelectedChildCategories(e.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Type</label>
                              <Select
                                isMulti
                                options={ServiceTypeOptions}
                                onChange={(selectedOptions) => {
                                  const selectedServiceTypes =
                                    selectedOptions.map((option) => ({
                                      selectedIds: option.value.toString(),
                                      selectedlabel: option.label.toString(),
                                    }));
                                  setSelectedServiceType(selectedServiceTypes);
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {Array.isArray(SelectServiceType) &&
                          SelectServiceType.map((item, index) => {
                            const regularPrice =
                              serviceVariants[index]?.VariantDescription[0]
                                .regularPrice || 0;
                            const salePrice =
                              serviceVariants[index]?.VariantDescription[0]
                                .salePrice || 0;
                            const newDiscountPercentage = Math.floor(
                              ((regularPrice - salePrice) / regularPrice) *
                                100 || 0
                            );
                            const file =
                              serviceVariants[index]?.VariantDescription[0]
                                .Imagee;

                            let imgSrc = "";
                            if (file) {
                              imgSrc = URL.createObjectURL(file);
                            }

                            // serviceVariants[index]?.VariantDescription[0]
                            //   .isDiscription

                            return (
                              <div key={index} className="card">
                                <div className="card-header">
                                  <h4 className="card-title mb-0 ">
                                    {item?.selectedlabel}
                                  </h4>
                                </div>
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Service Type</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Service Type"
                                          value={item?.selectedlabel}
                                          readOnly
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Service Group</label>
                                        <Select
                                          isMulti
                                          options={ServiceGroupOptions}
                                          onChange={(selectedOptions) => {
                                            const selectedIds =
                                              selectedOptions.map(
                                                (option) => option.value
                                              );

                                            console.log(
                                              "selectedIds",
                                              selectedIds
                                            );

                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ServiceGroup",
                                              selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Service Timing</label>
                                        <input
                                          type="text"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .ServiceTiming || ""
                                          }
                                          onChange={(e) =>
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ServiceTiming",
                                              e.target.value
                                            )
                                          }
                                          id="inputName"
                                          className="form-control"
                                          placeholder="Timing"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Regular Price</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Regular Price"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .regularPrice || ""
                                          }
                                          onChange={(e) =>
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "regularPrice",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Product Cost</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Product Cost"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .ProductCost || ""
                                          }
                                          onChange={(e) =>
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ProductCost",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Sale Price</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Sale Price"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .salePrice || ""
                                          }
                                          onChange={(e) => {
                                            const newSalePrice = e.target.value;
                                            const newDiscountPercentage =
                                              Math.floor(
                                                ((regularPrice - newSalePrice) /
                                                  regularPrice) *
                                                  100 || 0
                                              );
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "salePrice",
                                              newSalePrice
                                            );
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "serviceDiscount",
                                              newDiscountPercentage
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Discount (%)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Discount (%)"
                                          readOnly
                                          value={newDiscountPercentage}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Image</label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          accept="image/*"
                                          onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (file) {
                                              handleVariantChangee(
                                                item?.selectedIds,
                                                index,
                                                "Imagee",
                                                file
                                              );

                                              const reader = new FileReader();
                                              reader.onloadend = () => {
                                                setImagePreview(reader.result);
                                              };
                                              reader.readAsDataURL(file);
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div
                                        value={ServiceStatus}
                                        onChange={(e) =>
                                          handleVariantChangee(
                                            item?.selectedIds,
                                            index,
                                            "Status",
                                            e.target.value
                                          )
                                        }
                                        className="form-group"
                                      >
                                        <label>Status</label>
                                        <select className="form-control">
                                          <option value="">Select</option>
                                          <option value="1">Active</option>
                                          <option value="0">Inactive</option>
                                        </select>
                                      </div>
                                    </div>
                                    {imagePreview && (
                                      <div className="col-lg-4">
                                        <img
                                          width="80"
                                          height="50"
                                          src={imgSrc}
                                          alt="Preview"
                                          style={{ maxWidth: "100%" }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Show in Child Category</label>
                                        <Select
                                          isMulti
                                          options={childCategoryOptions}
                                          onChange={(selectedOptions) => {
                                            const selectedIds =
                                              selectedOptions.map(
                                                (option) => option.value
                                              );
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ShowInChildCategory",
                                              selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Short Discription</label>
                                        <ReactQuill
                                          className="h-100"
                                          modules={{
                                            toolbar: [
                                              [{ header: [1, 2, false] }],
                                              [
                                                "bold",
                                                "italic",
                                                "underline",
                                                "strike",
                                                "blockquote",
                                              ],
                                              [
                                                { list: "ordered" },
                                                { list: "bullet" },
                                                { indent: "-1" },
                                                { indent: "+1" },
                                              ],
                                              ["link", "image"],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          formats={[
                                            "header",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strike",
                                            "blockquote",
                                            "list",
                                            "bullet",
                                            "indent",
                                            "link",
                                            "image",
                                          ]}
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .ShortDiscription
                                          }
                                          onChange={(e) => {
                                            setEditorData(e);
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ShortDiscription",
                                              e
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Discription</label>

                                        <ReactQuill
                                          className="h-100"
                                          modules={{
                                            toolbar: [
                                              [{ header: [1, 2, false] }],
                                              [
                                                "bold",
                                                "italic",
                                                "underline",
                                                "strike",
                                                "blockquote",
                                              ],
                                              [
                                                { list: "ordered" },
                                                { list: "bullet" },
                                                { indent: "-1" },
                                                { indent: "+1" },
                                              ],
                                              ["link", "image"],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          formats={[
                                            "header",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strike",
                                            "blockquote",
                                            "list",
                                            "bullet",
                                            "indent",
                                            "link",
                                            "image",
                                          ]}
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .Discription
                                          }
                                          onChange={(e) => {
                                            setEditorData1(e);
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "Discription",
                                              e
                                            );
                                          }}
                                        />
                                      </div>

                                      <div className="custom-control custom-control-inline custom-checkbox">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id={`ckb${index}`}
                                          name="spCommentShow"
                                          checked={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .IsServiceDiscription == true
                                              ? true
                                              : false
                                          }
                                          value="1"
                                          onChange={(e) => {
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "IsServiceDiscription",
                                              !serviceVariants[index]
                                                ?.VariantDescription[0]
                                                .IsServiceDiscription
                                            );
                                          }}
                                        />{" "}
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`ckb${index}`}
                                        >
                                          Is Description
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <button
                          disabled={loading ? true : false}
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light loader"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <span>Create Service</span>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewService;
